"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ThemeWrapper_component_exports = {};
__export(ThemeWrapper_component_exports, {
  ThemeWrapper: () => ThemeWrapper
});
module.exports = __toCommonJS(ThemeWrapper_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var import_useLocalStorage = require("../../utils/useLocalStorage/useLocalStorage.hook");
const ThemeWrapper = (_a) => {
  var _b = _a, { as, children } = _b, props = __objRest(_b, ["as", "children"]);
  const As = as;
  let urlThemeValue = "";
  const [storedTheme, setStoredTheme] = (0, import_useLocalStorage.useLocalStorage)("gmui_theme", ``);
  (0, import_react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    urlThemeValue = queryParams.get("gmui-theme");
    if (!!urlThemeValue) {
      urlThemeValue === "reset" || urlThemeValue === void 0 ? setStoredTheme("") : setStoredTheme(urlThemeValue);
    }
  }, [window.location.search]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(As, __spreadProps(__spreadValues({ "data-gmui-theme": storedTheme }, props), { children }));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ThemeWrapper
});
//# sourceMappingURL=ThemeWrapper.component.js.map